import React, { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../components/Footers/Footer"

const API_BASE = "https://appapi.unpaidfinancial.com/api"; // change selon ton backend

const colors = {
  bg: "#f1f5f9", // bluegray-100
  card: "#fff",
  title: "#1e293b", // bluegray-800
  subtitle: "#475569", // bluegray-400
  accent: "#ef4444", // rouge-500
  border: "#e2e8f0" // bluegray-200
};

export default function TemoignagesPage() {
  const [temoignages, setTemoignages] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE}/temoignages`)
      .then((res) => setTemoignages(res.data))
      .catch(() => setTemoignages([]));
  }, []);

  return (
    <div
      style={{
        background: colors.bg,
        minHeight: "100vh",
        padding: "0",
        margin: "0"
      }}
    >
      <div style={{ maxWidth: 950, margin: "0 auto", padding: "40px 14px 30px 14px", marginTop:"50px" }}>
        {/* Eloges */}
        <div style={{
          textAlign: "center",
          marginBottom: 36,
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 4px 18px 0 rgba(30,41,59,0.05)",
          padding: "36px 10px 28px 10px",
          border: `1.5px solid ${colors.border}`,
        }}>
          <h1 style={{
            fontSize: "2.6rem",
            color: colors.title,
            fontWeight: 900,
            marginBottom: 10,
            letterSpacing: ".7px",
          }}>
            Ce que disent nos bénéficiaires
          </h1>
          <div style={{
            fontSize: "1.3rem",
            color: colors.subtitle,
            fontWeight: 500,
            margin: "auto",
            maxWidth: 660,
            lineHeight: 1.6
          }}>
            Chez <span style={{ color: colors.accent, fontWeight: 700 }}>AidFoundation</span>, nous croyons que chaque histoire compte.<br />
Grâce à notre accompagnement personnalisé et à notre engagement auprès de nos bénéficiaires, nous avons pu transformer la vie de nombreuses personnes et les aider à concrétiser leurs projets.<br />
Découvrez ci-dessous quelques témoignages de ceux qui, grâce à AidFoundation, ont franchi une étape décisive dans leur parcours.

          </div>
        </div>
        {/* Liste des témoignages */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
            gap: "32px",
            marginTop: "18px"
          }}
        >
          {temoignages.length === 0 ? (
            <div style={{ gridColumn: "1/-1", textAlign: "center", color: colors.subtitle, fontSize: 18 }}>
              Aucun témoignage pour le moment.
            </div>
          ) : (
            temoignages.map((t) => (
              <div
                key={t.id}
                style={{
                  background: colors.card,
                  borderRadius: 18,
                  padding: "32px 22px 24px 22px",
                  boxShadow: "0 6px 24px 0 rgba(30,41,59,0.09)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  border: `1.3px solid ${colors.border}`,
                  position: "relative",
                  minHeight: 280,
                }}
              >
                <div
                  style={{
                    width: 84,
                    height: 84,
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: `4px solid ${colors.accent}`,
                    marginBottom: 14,
                    boxShadow: "0 2px 12px 0 rgba(239,68,68,0.07)"
                  }}
                >
                  {t.photo ? (
                    <img
                      src={`${API_BASE.replace("/api", "")}/storage/${t.photo}`}
                      alt={t.nom}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                      }}
                    />
                  ) : (
                    <div style={{
                      width: "100%",
                      height: "100%",
                      background: colors.subtitle,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontSize: 30,
                      fontWeight: 700
                    }}>
                      {t.nom ? t.nom.charAt(0).toUpperCase() : "?"}
                    </div>
                  )}
                </div>
                <div style={{
                  color: colors.title,
                  fontWeight: 700,
                  fontSize: "1.16rem",
                  marginBottom: 5,
                  letterSpacing: ".2px"
                }}>
                  {t.nom}
                </div>
                <div style={{
                  fontStyle: "italic",
                  color: colors.accent,
                  marginBottom: 10,
                  fontWeight: 600,
                  fontSize: "1.01rem"
                }}>
                  <i className="fas fa-quote-left" style={{ marginRight: 6 }}></i>
                  {t.message}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
       
    </div>
  );
}
